/**
 * Enum containing all available permissions in the system
 * Keys are in camelCase for TypeScript usage
 * Values remain in snake_case to match the backend API
 */
export enum EPermissions {
  // Campaign Management
  campaignCreate = 'campaign_create',
  campaignReadOwn = 'campaign_read_own',
  campaignReadAll = 'campaign_read_all',
  campaignUpdateOwn = 'campaign_update_own',
  campaignUpdateAll = 'campaign_update_all',
  campaignDeleteOwn = 'campaign_delete_own',
  campaignValidate = 'campaign_validate',
  campaignBriefingSelf = 'campaign_briefing_self',

  // Campaign Analytics
  campaignAnalyticsWrite = 'campaign_analytics_write',
  campaignAnalyticsReadOwn = 'campaign_analytics_read_own',
  campaignAnalyticsReadAll = 'campaign_analytics_read_all',
  campaignAnalyticsAnnotatorWrite = 'campaign_analytics_annotator_write',
  campaignAnalyticsBriefingSelf = 'campaign_analytics_briefing_self',
  campaignAnalyticsManualStatusCreate = 'campaign_analytics_manual_status_create',
  campaignAnalyticsManualStatusUpdateOwn = 'campaign_analytics_manual_status_update_own',
  campaignAnalyticsManualStatusUpdateAll = 'campaign_analytics_manual_status_update_all',
  campaignAnalyticsManualStatusReadOwn = 'campaign_analytics_manual_status_read_own',
  campaignAnalyticsManualStatusReadAll = 'campaign_analytics_manual_status_read_all',
  campaignAnalyticsManualMatchingStatusCreate = 'campaign_analytics_manual_matching_status_create',
  campaignAnalyticsManualMatchingStatusUpdateOwn = 'campaign_analytics_manual_matching_status_update_own',
  campaignAnalyticsManualMatchingStatusReadOwn = 'campaign_analytics_manual_matching_status_read_own',

  // Manual Finding Status
  manualFindingStatusCreate = 'manual_finding_status_create',
  manualFindingStatusReadOwn = 'manual_finding_status_read_own',
  manualFindingStatusUpdateOwn = 'manual_finding_status_update_own',

  // Events
  eventsCreate = 'events_create',

  // Currency
  currencyRead = 'currency_read',

  // Creator Management
  creatorCreate = 'creator_create',
  creatorReadOwn = 'creator_read_own',
  creatorReadAll = 'creator_read_all',
  creatorUpdateOwn = 'creator_update_own',
  creatorDeleteOwn = 'creator_delete_own',
  creatorReadSelf = 'creator_read_self',
  creatorUpdateSelf = 'creator_update_self',
  creatorDeleteAll = 'creator_delete_all',
  creatorValidate = 'creator_validate',
  creatorAuthenticate = 'creator_authenticate',
  creatorFollowersRead = 'creator_followers_read',

  // Creator Analytics
  creatorAnalyticsWrite = 'creator_analytics_write',
  creatorAnalyticsReadOwn = 'creator_analytics_read_own',
  creatorAnalyticsReadAll = 'creator_analytics_read_all',
  creatorAnalyticsDeleteAll = 'creator_analytics_delete_all',
  creatorAnalyticsReadSelf = 'creator_analytics_read_self',

  // Customer Management
  customerCreate = 'customer_create',
  customerReadOwn = 'customer_read_own',
  customerUpdateOwn = 'customer_update_own',
  customerDeleteOwn = 'customer_delete_own',

  // Annotator Management
  annotatorCreate = 'annotator_create',
  annotatorRead = 'annotator_read',
  annotatorUpdate = 'annotator_update',
  annotatorDelete = 'annotator_delete',

  // User Management
  userReadOwn = 'user_read_own',
  userReadAll = 'user_read_all',
  userUpdateOwn = 'user_update_own',
  userUpdateAll = 'user_update_all',
  userDeleteAll = 'user_delete_all',
  userChangeRoleOwn = 'user_change_role_own',
  userChangeRoleAll = 'user_change_role_all',
  userChangeTeamOwn = 'user_change_team_own',
  userChangeTeamAll = 'user_change_team_all',

  // Role Management
  roleCreate = 'role_create',
  roleReadOwn = 'role_read_own',
  roleUpdateOwn = 'role_update_own',
  roleDeleteOwn = 'role_delete_own',

  // Team Management
  teamCreate = 'team_create',
  teamReadOwn = 'team_read_own',
  teamUpdateOwn = 'team_update_own',
  teamDeleteOwn = 'team_delete_own',

  // User Group Management
  userGroupReadOwn = 'user_group_read_own',
  userGroupReadAll = 'user_group_read_all',
  userGroupUpdateAll = 'user_group_update_all',
  userGroupSwitchOwn = 'user_group_switch_own',
  userGroupSwitchAll = 'user_group_switch_all',
  userGroupDeleteMemberOwn = 'user_group_delete_member_own',

  // User Feedback
  userFeedbackCreate = 'user_feedback_create',
  userFeedbackReadAll = 'user_feedback_read_all',
  userFeedbackUpdateAll = 'user_feedback_update_all',

  // Invitation Management
  campaignUserInvitationCreate = 'campaign_user_invitation_create',
  campaignSubUserInvitationCreate = 'campaign_sub_user_invitation_create',
  supportUserInvitationCreate = 'support_user_invitation_create',
  creatorInvitationCreate = 'creator_invitation_create',
  campaignUserInvitationReadOwn = 'campaign_user_invitation_read_own',
  campaignSubUserInvitationReadOwn = 'campaign_sub_user_invitation_read_own',
  supportUserInvitationReadOwn = 'support_user_invitation_read_own',
  creatorInvitationReadOwn = 'creator_invitation_read_own',
  invitationReadAll = 'invitation_read_all',

  // News Management
  newsCreate = 'news_create',
  newsReadOwn = 'news_read_own',
  newsReadAll = 'news_read_all',
  newsUpdateAll = 'news_update_all',
  newsDeleteAll = 'news_delete_all',

  // Image Management
  imagesCreate = 'images_create',
  imagesReadOwn = 'images_read_own',
  imagesReadAll = 'images_read_all',
  imagesDeleteOwn = 'images_delete_own',

  // Games Management
  gamesCreate = 'games_create',

  // Configuration Management
  deliverableConfigUpdate = 'deliverable_config_update',
  globalConfigRead = 'global_config_read',
  globalConfigUpdate = 'global_config_update',

  // System
  maintenanceModeIgnore = 'maintenance_mode_ignore',
}
